import { Component, Input } from '@angular/core'
import { Router } from '@angular/router'
import { NavTabGroup } from 'src/app/features/nav-tab-group/nav-tab-group.model'
import { LogonService } from 'src/app/services/logon/logon.service'
import { environment } from 'src/environments/environment'
import { AdobeLaunchService } from 'src/server/adobe-launch/adobe-launch.service'

@Component({
  selector: 'buy-button',
  providers: [],
  templateUrl: './buy-button.component.html',
  styleUrls: ['./buy-button.component.scss'],
})
export class BuyButtonComponent {
  @Input() fundInput: NavTabGroup
  @Input() size: string

  public vfeUrl = environment.vfeURLPrefix
  public vfaPersonal1Url = environment.vfaPersonal1Url
  public user = environment.UserLocation
  public href: string
  public isLoggedOn: any

  constructor(
    private readonly logonService: LogonService,
    public adobeLaunchService: AdobeLaunchService,
    private readonly router: Router,
  ) {
    this.href = this.router.url
  }
  // eslint-disable-next-line complexity,max-statements
  async buyFunds() {
    await this.getLogOnData()
    if (this.fundInput.isInternalFund) {
      if (
        this.fundInput.isETF &&
        !this.fundInput.isClosed &&
        !this.fundInput.isClosedToNewInvestors
      ) {
        this.ETFBuyButtonRedirect()
      } else if (
        this.fundInput.isMutualFund &&
        !this.fundInput.isClosed &&
        !this.fundInput.isClosedToNewInvestors
      ) {
        this.MFBuyButtonRedirect()
      } else if (this.fundInput.is529 && !this.fundInput.isClosed) {
        if (this.fundInput.isMutualFund) {
          this.MFBuyButtonRedirect()
        } else if (this.fundInput.isETF) {
          this.ETFBuyButtonRedirect()
        }
      }
      this.adobeLaunch()
    } else if (
      this.fundInput.isExternalFund &&
      this.fundInput.isETF &&
      !(this.fundInput.isClosed || this.fundInput.isClosedToNewInvestors)
    ) {
      this.ETFBuyButtonRedirect()
    } else if (this.fundInput.isExternalFund) {
      this.buyExternal()
    }
  }
  MFBuyButtonRedirect = () => {
    const finalURL = this.vfeUrl.concat(
      'BuySellRouter?investmentType=MUTL&nonRetirementMode=true&ticker='
        .concat(this.fundInput.ticker)
        .concat('&transactionType=BUY'),
    )
    this.updateWindow(finalURL)
  }
  ETFBuyButtonRedirect = () => {
    const finalURL = this.vfeUrl.concat(
      'BuySellRouter?investmentType=EQUITY&nonRetirementMode=true&ticker='
        .concat(this.fundInput.ticker)
        .concat('&transactionType=BUY'),
    )
    this.updateWindow(finalURL)
  }
  async adobeLaunch() {
    await this.getLogOnData()
    this.adobeLaunchService.callToAction(
      'Buy',
      `VMF ${this.fundInput.ticker} - ${this.fundInput.fundName} - Dashboard Section - Fund ID ${this.fundInput.fundId}`,
      'Button',
    )
    if (!this.isLoggedOn) {
      this.adobeLaunchService.touchPoint(
        this.href.substring(1),
        'Button',
        'OOA',
        'mmx',
      )
    } else {
      this.adobeLaunchService.touchPoint(
        this.href.substring(1),
        'Button',
        'buy',
        'transact',
      )
    }
  }
  async buyExternal() {
    await this.getLogOnData()
    if (this.isLoggedOn) {
      this.adobeLaunchService.touchPoint(
        this.href.substring(1),
        'Button',
        'buy',
        'transact',
      )
    } else {
      this.adobeLaunchService.touchPoint(
        this.href.substring(1),
        'Button',
        'OOA',
        'mmx',
      )
    }
    const finalURL = environment.externalUrl.concat(
      `us/BuySellRouter?investmentType=FUND_ACCESS_MUTUAL_FUND&transactionType=BUY&ticker=${this.fundInput.ticker}`,
    )
    this.updateWindow(finalURL)
  }

  getLogOnData() {
    return this.logonService.getLoggedOn().then(
      (response) => (this.isLoggedOn = Object.values(response)[1]),
      () => (this.isLoggedOn = false),
    )
  }

  updateWindow(url) {
    window.location.assign(url)
  }
}
